import { Anchor, Box, Button, Container, Stack, Text, Title } from "@mantine/core";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/api/resources/auth/hooks";
import { contactHelpAddress } from "@/configs/contactInformation";
import { useNavigationAnonymous } from "@/hooks/useNavigation";
import Icon from "@/utils/icons";

import styles from "./RouterNotFound.module.css";

export const RouterNotFound = () => {
  const { t } = useTranslation();
  const { goToLogin, goToDashboard } = useNavigationAnonymous();
  const { isAuthenticated } = useAuth();

  useLayoutEffect(() => {
    if (!isAuthenticated) {
      goToLogin();
    }
  }, [goToLogin, isAuthenticated]);

  return (
    <Container px="xl">
      <Box pos="relative">
        <Icon.FILE_MISSING className={styles.icon} />
        <Stack pt="24vh" maw="70%" mx="auto" align="center">
          <Title order={3} ta="center" mb="md">
            {t("404.title")}
          </Title>
          <Text c="dimmed" size="md" ta="center">
            {t("404.text")}

            <Anchor href={`mailto:${contactHelpAddress}`} target="_blank">
              {contactHelpAddress}
            </Anchor>
          </Text>

          <Button onClick={goToDashboard}>{t("404.button")}</Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default RouterNotFound;
